import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import UseStyle from "../../../css/styles";
import { format } from "date-fns";
import { useEffect, useState } from "react";//FB 7469


// Update log
// FB  6192   02/06/2023  DK  Added page to identify user details during registration
// FB  7045   07/19/2023  KK  PP- Unable to enter Date fields manually
// FB  7239   08/17/2023  KK  PP- DOB when entered manually is not taken into account
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7528   10/05/2023  DK  Issue with DOB field (Picking a day earlier)

export default function IdentifyUser(props: any) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });
  const styles = UseStyle();
  const handleDateChange = async (date: any) => {
    if (date != null && date != "Invalid Date") {
      //FB 7528
      props.handleInputChange(date); // FB 7239 KK
    }
  };
  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        <strong>Provide patient record details</strong>
      </Typography>
      <Typography>
        To create an account, we will need to confirm that you are a patient at {" "}
        {HeaderText}. Please enter the following information so we can find
        your records.
      </Typography>{/* FB 7469 */}
      <br />
      <Typography>
        Already have an {HeaderText} account? <a href="/user/login">Sign in</a>{/* FB 7469 */}
      </Typography>
      <hr />
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            id="PatientFirstName"
            name="PatientFirstName"
            label="First name"
            value={props.patient.PatientFirstName}
            onChange={props.handleInputChange}
            error={props.errors.PatientFirstName}
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <br />
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <TextField
            id="PatientLastName"
            name="PatientLastName"
            label="Last name"
            value={props.patient.PatientLastName}
            onChange={props.handleInputChange}
            error={props.errors.PatientLastName}
            variant="standard"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
          {/* FB 7045 KK Begin */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                InputLabelProps={{ shrink: true }}
                id="PatientDOB"
                name="PatientDOB"
                label="Date of Birth"
                className={styles.datepickerroot}
                value={props.patient.PatientDOB}
                format="MM/dd/yyyy"
                placeholder="MM/dd/yyyy"
                openTo="year"
                views={["year", "month", "date"]}
                onChange={(date) => handleDateChange(date)}
                error={props.errors.PatientDOB}
                inputVariant="standard"
                orientation="portrait"
                invalidDateMessage={
                  props.patient.PatientDOB == null ? "" : "Invalid Date"
                }
                disableFuture
                required
                fullWidth
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
          {/* FB 7045 KK End */}
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl required error={props.errors.PatientGender}>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Gender
            </FormLabel>
            <RadioGroup
              row
              name="PatientGender"
              id="PatientGender"
              aria-labelledby="demo-row-radio-buttons-group-label"
              value={props.patient.PatientGender}
              onChange={props.handleInputChange}
            >
              <FormControlLabel value="1" control={<Radio />} label="Male" />
              <FormControlLabel value="2" control={<Radio />} label="Female" />
              <FormControlLabel value="3" control={<Radio />} label="Unknown" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4} alignSelf="center">
          <TextField
            id="PatientZIP"
            name="PatientZIP"
            label="Zip code"
            value={props.patient.PatientZIP}
            onChange={props.handleInputChange}
            error={props.errors.PatientZIP}
            variant="standard"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6} lg={4}>
          <FormControl
            required
            variant="standard"
            sx={{ m: 1, minWidth: 120 }}
            style={{
              display: props.patient.PatientGender == "3" ? "flex" : "none",
            }}
          >
            {/* <InputLabel id="demo-simple-select-standard-label">
              Other Gender
            </InputLabel>
            <Select
              labelId="demo-simple-select-standard-label"
              id="PatientGender2"
              name="PatientGender2"
              value={props.patient.PatientGender2}
              onChange={props.handleInputChange}
              label="Other Gender"
              fullWidth
              error={props.errors.PatientGender2}
            >
              <MenuItem value="TF">Transgender Female</MenuItem>
              <MenuItem value="TM">Transgender Male</MenuItem>
              <MenuItem value="NB">Non-binary</MenuItem>
              <MenuItem value="ND">Non-disclosure</MenuItem>
            </Select> */}
          </FormControl>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
